<template>
    <div>
        <page-header pageTitle="SITUATIONS.INDEX_TITLE"/>

        <div class="row gutters mt-2" v-if="situationsIndex?.length">
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12"
                 v-for="(iten, key) in situationsIndex" :key="iten.id">
                <div class="card situation-card">
                    <div class="dynamic-background-card situation-lot-card"
                         :style="{'--dynamic-bg': iten.backgroud_collor}">
                        <h3 class="dynamic-text-color" :style="{'--dynamic-color': iten.text_collor}">000{{ key + 1 }}</h3>
                        <p class="dynamic-text-color" :style="{'--dynamic-color': iten.text_collor}">999 m²</p>
                        <p class="font-weight-bold dynamic-text-color"
                           :style="{'--dynamic-color': iten.text_collor}">R$ 50.000,00</p>
                    </div>
                    <div class="situation-card__fields" v-if="this.$hasPermission('PropertiesStatus_show')">
                        <div class="form-group">
                            <label>{{ t('PROPERTIES.DESCRIPTION') }}</label>
                            <input type="text" class="form-control" v-model="iten.name" disabled>
                        </div>
                        <div class="form-group">
                            <label>{{ t('SITUATIONS.BACKGROUND_COLOR') }}</label>
                            <div class="situation-color">
                                <input type="color" class="form-control situation-color-input"
                                       v-model="iten.backgroud_collor"
                                       @focus="setOriginalSituation(iten.backgroud_collor)"
                                       @change="updateSituation(iten.backgroud_collor, iten, key, 'SITUATIONS.BACKGROUND_COLOR')"
                                       :disabled="!this.$hasPermission('PropertiesStatus_update')">
                                <span class="situation-color-value">{{ iten.backgroud_collor }}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>{{ t('SITUATIONS.TEXT_COLOR') }}</label>
                            <div class="situation-color">
                                <input type="color" class="form-control situation-color-input"
                                       v-model="iten.text_collor"
                                       @focus="setOriginalSituation(iten.text_collor)"
                                       @change="updateSituation(iten.text_collor, iten, key, 'SITUATIONS.TEXT_COLOR')"
                                       :disabled="!this.$hasPermission('PropertiesStatus_update')">
                                <span class="situation-color-value">{{ iten.text_collor }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-if="!situationsIndex?.length">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NO_REGISTER', {name: t('SITUATIONS.INDEX_TITLE'), os: 'as'}) }}</h5>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";
import Properties from "@/services/Properties";
import Validate from '@/components/validate.vue';
import pageHeader from "@/components/layouts/pageHeader";

export default {
    name: 'indexSituation',
    mixins: [Validate],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            situationsIndex: [],
            originalSituation: {},
        }
    },
    components: {
        pageHeader,
    },
    mounted() {
        this.$canAccess('PropertiesStatus_index');
        this.$store.commit('changeLoading', true);
        this.indexSituation();
    },
    methods: {
        async indexSituation() {
            await Properties.indexSituation().then(resp => {
                this.situationsIndex = resp.data.data;
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });
        },

        setOriginalSituation(situation) {
            this.originalSituation = situation;
        },
        updateSituation(target, situation, key, msg) {
            if (target != this.originalSituation) {
                Properties.updateSituation(situation).then(resp => {
                    this.situationsIndex[key] = resp.data;
                    this.toast.success(this.t('GENERAL.MSG.PLACEHOLDER_UPDATE_SUCCESS', {name: this.t(msg)}));
                }).catch(error => {
                    this.errorMsg(error);
                });
            }
        },
    },
}
</script>
<style lang="css">
.situation-card {
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
    margin-bottom: 10px;
    padding: 15px 15px 10px 15px;
}

.situation-lot-card {
    align-items: center;
    border-radius: 12px;
    border: 0;
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 1rem;
    min-height: 140px;
    text-align: center;
}

.situation-lot-card h3 {
    font-size: 1.5rem;
}

.situation-lot-card p {
    font-size: 0.9rem;
    margin-bottom: 0.4rem;
}

.situation-card__fields .form-group {
    margin-bottom: 0.85rem;
}

.situation-card__fields label {
    color: #173b34;
    display: block;
    font-size: 0.78rem;
    font-weight: 800;
    margin-bottom: 0.35rem;
}

.situation-color {
    align-items: center;
    display: flex;
    gap: 0.5rem;
}

.situation-color-input {
    border-radius: 8px;
    flex: 0 0 46px;
    height: 38px;
    padding: 0.2rem;
    width: 46px;
}

.situation-color-input:disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

.situation-color-value {
    color: #6b7c78;
    font-size: 0.75rem;
    font-weight: 700;
}

html.dark-theme .situation-card {
    border-color: var(--dark-border) !important;
}

html.dark-theme .situation-card__fields label {
    color: var(--dark-text) !important;
}

html.dark-theme .situation-color-value {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .situation-lot-card {
    box-shadow: 0 12px 26px rgba(2, 6, 23, 0.34);
}
</style>
